(() => {
  if (window.coolmistInlineVideos) {
    window.coolmistInlineVideos.init(document);
    return;
  }
  const roots = new Map();
  const selector = '[data-coolmist-clean-page]';
  const pauseAll = root => root.querySelectorAll('video').forEach(video => {
    if (!video.paused) video.pause();
  });
  const initialize = root => {
    if (roots.has(root)) return;
    const controller = new AbortController();
    const on = (target, type, handler, options = {}) => target?.addEventListener(type, handler, { ...options, signal: controller.signal });
    roots.set(root, controller);
    root.dataset.videoInteractionsReady = 'true';
    const actionVideo = root.querySelector('.cm-clean-action-video');
    let actionPlayback;
    const pauseOthers = current => {
      if (current !== actionVideo) actionPlayback?.yield();
      root.querySelectorAll('video').forEach(video => {
        if (video !== current && !video.paused) video.pause();
      });
    };
    const updateButton = (button, video) => {
      const playing = !video.paused;
      const label = playing ? 'Pause video' : 'Play video';
      const symbol = playing ? 'Ⅱ' : '▶';
      if (button.textContent !== symbol) button.textContent = symbol;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(playing));
      button.classList.toggle('is-playing', playing);
    };
    const toggle = card => {
      const video = card.querySelector('video');
      if (!video) return;
      if (!video.paused) { video.pause(); return; }
      pauseOthers(video);
      video.muted = false;
      let loaded = false;
      video.querySelectorAll('source[data-src]').forEach(source => {
        if (source.hasAttribute('src')) return;
        source.src = source.dataset.src;
        loaded = true;
      });
      if (loaded) video.load();
      video.play()?.catch(error => {
        if (controller.signal.aborted || error.name === 'AbortError') return;
        video.controls = true;
      });
    };
    root.querySelectorAll('video').forEach(video => on(video, 'play', () => pauseOthers(video)));
    if (actionVideo) {
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
      let visible = false;
      let manualPause = false;
      let interrupted = false;
      let blocked = false;
      let pending = false;
      let shouldPlay = false;
      actionVideo.muted = true;
      actionVideo.defaultMuted = true;
      actionVideo.playsInline = true;
      actionVideo.preload = 'none';
      const update = () => {
        const playing = !actionVideo.paused;
        const label = playing ? actionVideo.dataset.pauseLabel : actionVideo.dataset.playLabel;
        if (label) actionVideo.setAttribute('aria-label', label);
        actionVideo.setAttribute('aria-pressed', String(playing));
      };
      const stop = () => {
        shouldPlay = false;
        actionVideo.pause();
      };
      const start = (manual = false) => {
        if (controller.signal.aborted || document.hidden) return;
        if (!manual && (!visible || manualPause || interrupted || blocked || actionVideo.ended || reducedMotion?.matches)) return;
        if (manual) { manualPause = false; interrupted = false; blocked = false; }
        shouldPlay = true;
        if (pending || !actionVideo.paused) return;
        actionVideo.muted = true;
        pauseOthers(actionVideo);
        let loaded = false;
        actionVideo.querySelectorAll('source[data-src]').forEach(source => {
          if (source.hasAttribute('src')) return;
          source.src = source.dataset.src;
          loaded = true;
        });
        if (loaded) actionVideo.load();
        pending = true;
        Promise.resolve(actionVideo.play()).then(() => {
          if (controller.signal.aborted || !shouldPlay || document.hidden) actionVideo.pause();
        }).catch(error => {
          if (controller.signal.aborted || error.name === 'AbortError') return;
          blocked = true;
          shouldPlay = false;
        }).finally(() => { pending = false; update(); });
      };
      actionPlayback = {
        intersect(entry) {
          const next = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          if (visible === next) return;
          visible = next;
          if (visible) start();
          else { interrupted = false; stop(); }
        },
        resume: () => start(),
        suspend: stop,
        yield() { if (visible) interrupted = true; stop(); }
      };
      const toggleAction = () => {
        if (!actionVideo.paused || (pending && shouldPlay)) { manualPause = true; stop(); }
        else start(true);
      };
      on(actionVideo, 'click', toggleAction);
      on(actionVideo, 'keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggleAction();
      });
      ['play', 'pause', 'ended'].forEach(type => on(actionVideo, type, update));
      on(actionVideo, 'volumechange', () => { if (!actionVideo.muted) actionVideo.muted = true; });
      on(actionVideo, 'playing', () => {
        if (!shouldPlay || document.hidden || controller.signal.aborted) actionVideo.pause();
      });
      controller.signal.addEventListener('abort', stop, { once: true });
      update();
    }
    root.querySelectorAll('.cm-clean-social-card').forEach(card => {
      const video = card.querySelector('video');
      if (!video) return;
      video.autoplay = false;
      video.preload = 'none';
      video.muted = false;
      video.defaultMuted = false;
      video.playsInline = true;
      let button = card.querySelector('.cm-clean-social-play');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'cm-clean-social-play';
        card.appendChild(button);
      }
      card.tabIndex = 0;
      on(button, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        toggle(card);
      });
      on(card, 'click', event => {
        if (event.target.closest('button, a') || (event.target === video && video.controls)) return;
        toggle(card);
      });
      on(card, 'keydown', event => {
        if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        toggle(card);
      });
      ['play', 'pause', 'ended'].forEach(type => on(video, type, () => updateButton(button, video)));
      updateButton(button, video);
    });
    root.querySelectorAll('[data-slider="social"], [data-slider="features"], [data-slider="compare"]').forEach(strip => {
      let drag;
      let suppressClickUntil = 0;
      on(strip, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, a, input')) return;
        drag = { id: event.pointerId, x: event.clientX, left: strip.scrollLeft, moved: false };
      });
      on(strip, 'pointermove', event => {
        if (!drag || drag.id !== event.pointerId) return;
        const delta = event.clientX - drag.x;
        if (Math.abs(delta) > 6) {
          drag.moved = true;
          strip.setPointerCapture?.(event.pointerId);
          strip.classList.add('is-dragging');
        }
        if (drag.moved) {
          event.preventDefault();
          strip.scrollLeft = drag.left - delta;
        }
      });
      const end = event => {
        if (!drag || drag.id !== event.pointerId) return;
        if (drag.moved) suppressClickUntil = performance.now() + 350;
        if (strip.hasPointerCapture?.(event.pointerId)) strip.releasePointerCapture(event.pointerId);
        strip.classList.remove('is-dragging');
        drag = null;
      };
      on(window, 'pointerup', end);
      on(window, 'pointercancel', end);
      on(strip, 'click', event => {
        if (performance.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { capture: true });
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.target === actionVideo) actionPlayback?.intersect(entry);
        else if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
      }), { threshold: [0, 0.25] });
      root.querySelectorAll('video').forEach(video => observer.observe(video));
      controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }
    on(document, 'visibilitychange', () => {
      if (document.hidden) { actionPlayback?.suspend(); pauseAll(root); }
      else actionPlayback?.resume();
    });
    on(window, 'pagehide', () => { actionPlayback?.suspend(); pauseAll(root); });
    on(window, 'pageshow', () => actionPlayback?.resume());
    controller.signal.addEventListener('abort', () => {
      pauseAll(root);
      delete root.dataset.videoInteractionsReady;
      roots.delete(root);
    }, { once: true });
  };
  const matchingRoots = scope => scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
  const init = (scope = document) => matchingRoots(scope).forEach(initialize);
  window.coolmistInlineVideos = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => matchingRoots(event.target).forEach(root => roots.get(root)?.abort()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  if (!document.getElementById('coolmist-clean-video-interactions-style')) {
    const style = document.createElement('style');
    style.id = 'coolmist-clean-video-interactions-style';
    style.textContent = `
      .cm-clean-social-strip { touch-action: auto; }
      .cm-clean-social-strip.is-dragging { cursor: grabbing; scroll-behavior: auto !important; }
      .cm-clean-social-card { cursor: pointer; }
      .cm-clean-social-play { position: absolute; inset: 10px 10px auto auto; z-index: 3; display: grid; width: 32px; height: 32px; min-width: 0; min-height: 0; place-items: center; padding: 0 0 0 2px; transform: none; border: 0; border-radius: 50%; background: rgb(255 255 255 / 90%); color: #111; font: 700 12px/1 Arial, sans-serif; cursor: pointer; box-shadow: 0 2px 8px rgb(0 0 0 / 14%); }
      .cm-clean-social-play::after { content: ''; position: absolute; inset: -6px; }
      .cm-clean-social-play.is-playing { padding-left: 0; font-size: 12px; }
      .cm-clean-social-play:focus-visible { outline: 3px solid #4b247d; outline-offset: 3px; }
      .cm-clean-social-card::after { display: none !important; }
    `;
    document.head.appendChild(style);
  }
})();
